import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
}

const defaultTitle = '亚洲综合网 - 亚洲资讯娱乐一站式平台';
const defaultDesc = '亚洲综合网是专注亚洲地区的综合性信息平台，汇聚亚洲娱乐、财经、科技、生活等全品类内容，为用户提供最新、最全、最权威的亚洲资讯服务。';
const defaultKeywords = '亚洲综合网,亚洲综合资讯平台,亚洲娱乐综合网站,亚洲财经综合信息,亚洲生活资讯网,亚洲综合门户网站,亚洲多媒体综合平台';

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: SEOHeadProps) {
  const pageTitle = title ? `${title} - 亚洲综合网` : defaultTitle;
  const pageDesc = description || defaultDesc;
  const pageKeywords = keywords || defaultKeywords;
  const pageUrl = canonicalUrl || 'https://985huidian.cn';
  const pageImage = ogImage || 'https://985huidian.cn/og-image.jpg';

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, property?: string) => {
      const selector = property
        ? `meta[property="${property}"]`
        : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        if (property) {
          el.setAttribute('property', property);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDesc);
    setMeta('keywords', pageKeywords);
    setMeta('og:title', pageTitle, 'og:title');
    setMeta('og:description', pageDesc, 'og:description');
    setMeta('og:type', ogType, 'og:type');
    setMeta('og:url', pageUrl, 'og:url');
    setMeta('og:image', pageImage, 'og:image');
    setMeta('twitter:title', pageTitle, 'twitter:title');
    setMeta('twitter:description', pageDesc, 'twitter:description');
    setMeta('twitter:image', pageImage, 'twitter:image');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', pageUrl);
  }, [pageTitle, pageDesc, pageKeywords, pageUrl, pageImage, ogType]);

  return null;
}